module.exports = __webpack_public_path__ + "img/businessLogo.15f21301.png";